import { Link } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { AUDIENCE, WA_LINK, CATALOGUE_PDF } from "../data/site";

export const DealerCTA = () => (
  <section data-testid="dealer-cta-section" className="bg-brand-red py-20 sm:py-28 relative overflow-hidden">
    <div className="absolute inset-0 noise-overlay opacity-10 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold uppercase tracking-tight text-white leading-[1.05]">
              Looking for a Reliable Steel Frame Supplier?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-white/85 leading-relaxed max-w-2xl">
              Partner with MODORS for quality galvanized steel door and window frames for
              residential, commercial and industrial projects.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-7 flex flex-wrap gap-2">
              {AUDIENCE.map((a) => (
                <span
                  key={a}
                  className="text-[11px] font-semibold tracking-[0.18em] uppercase border border-white/40 text-white px-3.5 py-1.5"
                >
                  {a}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-4">
          <div className="flex flex-col gap-4">
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="become-dealer-btn"
              className="group inline-flex items-center justify-center gap-3 bg-brand-coal text-white text-sm font-semibold tracking-[0.14em] uppercase px-8 py-4 hover:bg-white hover:text-brand-ink transition-colors duration-300"
            >
              Become a Dealer
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </a>
            <Link
              to="/contact"
              data-testid="dealer-request-quote-btn"
              className="group inline-flex items-center justify-center gap-3 border-2 border-white text-white text-sm font-semibold tracking-[0.14em] uppercase px-8 py-4 hover:bg-white hover:text-brand-red transition-colors duration-300"
            >
              Request a Quote
            </Link>
            <a
              href={CATALOGUE_PDF}
              download="MODORS-Catalogue.pdf"
              data-testid="download-catalogue-btn"
              className="group inline-flex items-center justify-center gap-3 bg-white text-brand-ink text-sm font-semibold tracking-[0.14em] uppercase px-8 py-4 hover:bg-brand-coal hover:text-white transition-colors duration-300"
            >
              Download Catalogue
              <Download className="w-4 h-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
